import { render, staticRenderFns } from "./CDRQSummarySingleFileRow.vue?vue&type=template&id=4f60896f&scoped=true&"
import script from "./CDRQSummarySingleFileRow.vue?vue&type=script&lang=ts&"
export * from "./CDRQSummarySingleFileRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60896f",
  null
  
)

export default component.exports